export default class ModSimulador {
    constructor() {

        this.module = document.querySelector('.modulo-simulador')
        this.numberStores = document.querySelector('#numeroLojas')
        this.countLojas = this.module.querySelector('.countLojas')

        this.fieldNormalValue = this.module.querySelector('#valor_licenciamento')
        this.fieldInfyValue = this.module.querySelector('#valor_infymedia')
        this.economy = this.module.querySelector('#valor_economia')

        this.normalValue = this.fieldNormalValue.dataset.valor
        this.infyValue = this.fieldInfyValue.dataset.valor

        this.ready()

    }

    ready() {

        this.numberStores.addEventListener("input", (event) => {
            const totalLojas = +event.target.value
            this.countLojas.textContent = totalLojas;

            const clearStringNormal = this.normalValue.replace(',', '.')
            const clearStringInfy = this.infyValue.replace(',', '.')

            const newNormalValue = new Intl.NumberFormat("pt-br", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(parseFloat(clearStringNormal) * totalLojas)
            
            const newInfyValue = new Intl.NumberFormat("pt-br", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(parseFloat(clearStringInfy) * totalLojas)

            const calcEconomy = (parseFloat(clearStringNormal * totalLojas)) - (parseFloat(clearStringInfy * totalLojas))

            const newEconomy = new Intl.NumberFormat("pt-br", { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(calcEconomy)

            this.fieldNormalValue.textContent = newNormalValue
            this.fieldInfyValue.textContent = newInfyValue
            this.economy.textContent = newEconomy

        });
        
    }

}